<p-toast></p-toast>
<div *ngIf="isLoading" class="flex justify-content-center align-items-center h-full">
    <p-progressSpinner></p-progressSpinner>
</div>

<div *ngIf="!isLoading && settlement">
    <!-- Header -->
    <div class="p-4">
        <div class="flex justify-content-between align-items-start mb-4">
            <div>
                <h1 class="text-blue-800 text-3xl font-bold">Settlement #{{ settlement.id }}</h1>
                <p class="text-600 mt-1">Customer: {{ settlement.customer.customerName }}</p>
                <div class="text-white">
                    <p-chip [label]="settlement.activityType.name" [icon]="settlement.activityType.icon" class="bg-purple-300" />
                </div>
            </div>
            <div>
                <p-tag [value]="settlement.status?.statusName?.toUpperCase()" [severity]="getStatusSeverity()"
                    [rounded]="true" class="mr-2"></p-tag>
                <p-button *ngIf="settlement.promoPlanId" label="Show Promo Plan" icon="pi pi-caret-up" severity="help" (onClick)="navigateToPromoPlan()" class="mr-2"></p-button>
                <p-button label="Create Sellout" icon="pi pi-upload" severity="success" (onClick)="createSellout()" class="mr-2"></p-button>
                <p-button *ngIf="settlement.linkedSessionId" label="Open Session" icon="pi pi-telegram" severity="info" (onClick)="openSession()"></p-button>
            </div>
        </div>

        <!-- Settlement Request Details -->
        <div class="mt-4">
            <p-fieldset [toggleable]="true" class="mb-4">
                <ng-template pTemplate="header">
                    <div class="flex align-items-center justify-content-between w-full">
                        <span class="font-bold mr-2">Settlement Request</span>
                        <p-button label="Edit" icon="pi pi-pencil" styleClass="p-button-rounded" *ngIf="settlement.status?.statusName === 'Pending - Sales'"
                        (click)="editSettlement()" severity="help" [disabled]="currentUser?.id !== settlement.salesRep?.id" 
                        pTooltip="{{currentUser?.id !== settlement.salesRep?.id ? 'You do not have permission to edit' : ''}}"></p-button>
                    </div>
                </ng-template>
                <div class="grid">
                    <div *ngIf="settlement.promoPlanId" class="col-12 md:col-6 lg:col-4"><strong>Promo Plan ID:</strong>
                        <div class="mt-1">{{ settlement.promoPlanId || 'N/A' }}</div>
                    </div>
                    <div class="col-12 md:col-6 lg:col-4"><strong>Start Date:</strong>
                        <div class="mt-1">{{ settlement.startDate | appDate:'longDate' }}</div>
                    </div>
                    <div class="col-12 md:col-6 lg:col-4"><strong>End Date:</strong>
                        <div class="mt-1">{{ settlement.endDate | appDate:'longDate' }}</div>
                    </div>
                    <div *ngIf="settlement.promoPlanId" class="col-12 md:col-6 lg:col-4"><strong>Actual Start Date:</strong>
                        <div class="mt-1">{{ settlement.actualStartDate | appDate:'longDate' }}</div>
                    </div>
                    <div *ngIf="settlement.promoPlanId" class="col-12 md:col-6 lg:col-4"><strong>Actual End Date:</strong>
                        <div class="mt-1">{{ settlement.actualEndDate | appDate:'longDate' }}</div>
                    </div>
                    <div class="col-12 md:col-6 lg:col-4"><strong>Customer:</strong>
                        <div class="mt-1">{{ settlement.customer.customerNumber }} - {{ settlement.customer.customerName }}</div>
                    </div>
                    <div class="col-12 md:col-6 lg:col-4"><strong>Location:</strong>
                        <div class="mt-1">{{ settlement.location.locationNo }}</div>
                    </div>
                    <div class="col-12 md:col-6 lg:col-4"><strong>Branch:</strong>
                        <div class="mt-1">{{ settlement.branch?.name }}</div>
                    </div>
                    <div class="col-12 md:col-6 lg:col-4"><strong>Business Unit:</strong>
                        <div class="mt-1">{{ settlement.businessUnit?.businessUnitName }}</div>
                    </div>
                    <div class="col-12 md:col-6 lg:col-4"><strong>Business:</strong>
                        <div class="mt-1">{{ settlement.business?.businessName}}</div>
                    </div>
                    <div class="col-12 md:col-6 lg:col-4"><strong>Channel:</strong>
                        <div class="mt-1">{{ settlement.channel }}</div>
                    </div>
                    <div class="col-12 md:col-6 lg:col-4"><strong>Activity Type:</strong>
                        <div class="mt-1">{{ settlement.activityType.name }}</div>
                    </div>
                    <div class="col-12 md:col-6 lg:col-4"><strong>Value:</strong>
                        <div class="mt-1">{{ settlement.value | currency:'SAR' }}</div>
                    </div>
                    <div class="col-12 md:col-6 lg:col-4"><strong>VAT:</strong>
                        <div class="mt-1">{{ settlement.vat | currency:'SAR' }}</div>
                    </div>
                    <div class="col-12 md:col-6 lg:col-4"><strong>Total Amount:</strong>
                        <div class="mt-1">{{ settlement.totalAmount | currency:'SAR' }}</div>
                    </div>
                    <div class="col-12 md:col-6 lg:col-4"><strong>Customer Invoice#:</strong>
                        <div class="mt-1">{{ settlement.customerInvoiceNumber || 'N/A' }}</div>
                    </div>
                    <div class="col-12 md:col-6 lg:col-4"><strong>Sales Rep:</strong>
                        <div class="mt-1">{{ settlement.salesRep?.fullName }}</div>
                    </div>
                    <div class="col-12 md:col-6 lg:col-4" *ngIf="validatedSellout"><strong>Validated Sellout:</strong>
                        <div class="mt-1 flex align-items-center gap-2">
                            <p-tag [value]="validatedSellout.validationStatus || 'VALIDATED'"
                                [severity]="getHubValidationStatusSeverity(validatedSellout.validationStatus)"
                                [rounded]="true"></p-tag>
                            <span *ngIf="validatedSellout.totalAmount != null" class="font-bold">
                                {{ validatedSellout.totalAmount | currency:'SAR' }}
                            </span>
                            <p-button icon="pi pi-external-link" [rounded]="true" [text]="true" size="small"
                                pTooltip="Open Sellout #{{ validatedSellout.selloutId }}" tooltipPosition="top"
                                (onClick)="viewSellout(validatedSellout.selloutId)"></p-button>
                        </div>
                    </div>
                    <div class="col-12"><strong>Note:</strong>
                        <p class="mt-1 text-600">{{ settlement.note || 'N/A' }}</p>
                    </div>
                </div>
            </p-fieldset>
        </div>

        <div class="mt-4">
            <p-fieldset legend="Related Sellouts" [toggleable]="true" class="mb-4">
                <div *ngIf="isLoadingSelloutStatuses" class="flex align-items-center gap-2 text-600 p-2">
                    <p-progressSpinner [style]="{ width: '1.5rem', height: '1.5rem' }"></p-progressSpinner>
                    <span>Loading related sellouts...</span>
                </div>

                <p-table *ngIf="!isLoadingSelloutStatuses && selloutStatuses.length > 0" [value]="selloutStatuses"
                    styleClass="p-datatable-sm" responsiveLayout="scroll">
                    <ng-template pTemplate="header">
                        <tr>
                            <th style="width: 4rem"></th>
                            <th>Sellout ID</th>
                            <th>Batch #</th>
                            <th>Hub Validation Status</th>
                            <th>Workflow Status</th>
                            <th>Sellout Amount</th>
                            <th>Uploaded By</th>
                            <th>Created At</th>
                            <th>BigQuery Status</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-selloutStatus>
                        <tr>
                            <td>
                                <p-button icon="pi pi-eye" severity="info" [rounded]="true" [text]="true" size="small"
                                    pTooltip="View Sellout" tooltipPosition="top"
                                    (onClick)="viewSellout(selloutStatus.selloutId)"></p-button>
                            </td>
                            <td>
                                <span class="font-bold text-primary cursor-pointer hover:underline" (click)="viewSellout(selloutStatus.selloutId)">
                                    #{{ selloutStatus.selloutId }}
                                </span>
                            </td>
                            <td>{{ selloutStatus.batchNumber || '-' }}</td>
                            <td>
                                <p-tag *ngIf="selloutStatus.validationStatus; else noValStatus"
                                    [value]="selloutStatus.validationStatus"
                                    [severity]="getHubValidationStatusSeverity(selloutStatus.validationStatus)"
                                    [rounded]="true"></p-tag>
                                <ng-template #noValStatus>
                                    <span class="text-600">-</span>
                                </ng-template>
                            </td>
                            <td>
                                <p-tag *ngIf="selloutStatus.workflowStatus; else noWfStatus"
                                    [value]="selloutStatus.workflowStatus"
                                    [severity]="getSelloutWorkflowStatusSeverity(selloutStatus.workflowStatus)"
                                    [rounded]="true"></p-tag>
                                <ng-template #noWfStatus>
                                    <span class="text-600">-</span>
                                </ng-template>
                            </td>
                            <td>
                                <span *ngIf="selloutStatus.totalAmount != null" class="font-semibold">
                                    {{ selloutStatus.totalAmount | currency:'SAR' }}
                                </span>
                                <span *ngIf="selloutStatus.totalAmount == null">-</span>
                            </td>
                            <td>{{ selloutStatus.createdBy || '-' }}</td>
                            <td>{{ selloutStatus.createdAt | date:'short' }}</td>
                            <td>
                                <p-tag *ngIf="selloutStatus.status; else notAvailable"
                                    [value]="selloutStatus.status" [severity]="getSelloutStatusSeverity(selloutStatus.status)"
                                    [rounded]="true"></p-tag>
                                <ng-template #notAvailable>
                                    <span class="text-500 text-sm">Not in BigQuery</span>
                                </ng-template>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>

                <div *ngIf="!isLoadingSelloutStatuses && selloutStatusesError" class="text-orange-600 p-2">
                    Sellout calculation statuses are currently unavailable from BigQuery.
                </div>

                <div *ngIf="!isLoadingSelloutStatuses && !selloutStatusesError && selloutStatuses.length === 0"
                    class="text-center text-600 p-3">
                    No sellouts are linked to this settlement.
                </div>
            </p-fieldset>
        </div>


        <!-- Approval Workflow -->
        <div class="mt-4">
            <p-fieldset legend="Approval Workflow" [toggleable]="true" class="mb-4">
                <app-approval-card [invokedFromChat]="false" 
                        [businessObjectId]="settlement.id ?? 0"
                        [businessObjectDescription]="settlement.customer.customerName"
                        [currentUser]="currentUser" [approvalContext]="{ customerId: settlement.customer.id, businessId: settlement.business?.id, businessUnitId: settlement.businessUnit?.id, branchId: settlement.branch?.id }"
                        [workflowApprovals]="settlement.workflowApprovals ?? []" 
                        (statusChange)="onStatusChange($event)">
                </app-approval-card>
            </p-fieldset>
        </div>


        <!-- A&P Details -->
        <div class="mt-4">
            <p-fieldset legend="" [toggleable]="true" class="mb-4">
                <ng-template pTemplate="header">
                    <div class="flex align-items-center justify-content-between w-full">
                        <span class="font-bold mr-2">A&P Details (Budgetary Control)</span>
                        <p-button label="Edit" icon="pi pi-pencil" styleClass="p-button-rounded" *ngIf="settlement.status?.statusName === 'Pending - Budgetary Control'"
                        (click)="openEditApDialog()" severity="help" [disabled]="!canUpdateBudgetaryControl" 
                        pTooltip="{{!canUpdateBudgetaryControl ? 'You do not have permission to edit' : ''}}"></p-button>
                    </div>
                </ng-template>
                <div class="grid">
                    <div class="col-12 md:col-6 lg:col-4"><strong>AP Voucher:</strong>
                        <div class="mt-1">{{ settlement.apVoucher || 'N/A' }}</div>
                    </div>
                    <div class="col-12 md:col-6 lg:col-4"><strong>A&P Value:</strong>
                        <div class="mt-1">{{ settlement.apValue | currency:'SAR' }}</div>
                    </div>
                    <div class="col-12 md:col-6 lg:col-4"><strong>A&P VAT:</strong>
                        <div class="mt-1">{{ settlement.apVat | currency:'SAR' }}</div>
                    </div>
                    <div class="col-12 md:col-6 lg:col-4"><strong>A&P Total Amount:</strong>
                        <div class="mt-1">{{ settlement.apTotalAmount | currency:'SAR' }}</div>
                    </div>
                    <div class="col-12 md:col-6 lg:col-4"><strong>A&P AR GL Code:</strong>
                        <div class="mt-1">{{ settlement.apArGlCodeCombination || 'N/A' }}</div>
                    </div>
                    <div class="col-12 md:col-6 lg:col-4"><strong>A&P AP GL Code:</strong>
                        <div class="mt-1">{{ settlement.apApGlCodeCombination || 'N/A' }}</div>
                    </div>
                    <div class="col-12 md:col-6 lg:col-4"><strong>A&P Text Reference:</strong>
                        <div class="mt-1">{{ settlement.apTextReference || 'N/A' }}</div>
                    </div>
                    <div class="col-12 md:col-6 lg:col-4"><strong>Service Invoice:</strong>
                        <div class="mt-1">{{ settlement.serviceInvoice === true ? 'Yes' : (settlement.serviceInvoice === false ? 'No' : 'N/A') }}</div>
                    </div>
                    <div class="col-12 md:col-6 lg:col-4"><strong>Transaction Type:</strong>
                        <div class="mt-1">{{ settlement.transactionType || 'N/A' }}</div>
                    </div>
                    <div class="col-12 md:col-6 lg:col-4"><strong>Supplier:</strong>
                        <div class="mt-1">{{ settlement.supplierName || 'N/A' }}</div>
                    </div>
                    <div class="col-12 md:col-6 lg:col-4"><strong>Customer:</strong>
                        <div class="mt-1">{{ settlement.customer.customerNumber }} - {{ settlement.customer.customerName }}</div>
                    </div>
                    <div class="col-12 md:col-6 lg:col-4"><strong>Location:</strong>
                        <div class="mt-1">{{ settlement.location.locationNo }}</div>
                    </div>
                    <div class="col-12 md:col-6 lg:col-4"><strong>Ar TRX No:</strong>
                        <div class="mt-1">{{ settlement.arTrxNo }}</div>
                    </div>
                </div>
            </p-fieldset>
        </div>

        <!-- AR Finance Details -->
        <div class="mt-4">
            <p-fieldset legend="" [toggleable]="true" class="mb-4">
                <ng-template pTemplate="header">
                    <div class="flex align-items-center justify-content-between w-full">
                        <span class="font-bold mr-2">AR Finance Details</span>
                        <p-button label="Edit" icon="pi pi-pencil" styleClass="p-button-rounded" 
                        *ngIf="settlement.status?.statusName === 'Pending - Finance AR'"

                        (click)="openEditArDialog()" severity="help" [disabled]="!canUpdateFinance" 
                        pTooltip="{{!canUpdateFinance ? 'You do not have permission to edit' : ''}}"></p-button>
                    </div>
                </ng-template>
                
                <div class="grid">
                    <div class="col-12 md:col-6 lg:col-4"><strong>AR CM#:</strong>
                        <div class="mt-1">{{ settlement.arCmHash }}</div>
                    </div>
                    <!-- <div class="col-12 md:col-6 lg:col-4"><strong>AR TRX No:</strong>
                        <div class="mt-1">{{ settlement.arTrxNo || 'N/A' }}</div>
                    </div> -->

                </div>
            </p-fieldset>
        </div>


        <!-- System Information -->
        <div class="mt-4">
            <p-fieldset legend="System Information" [toggleable]="true" [collapsed]="true">
                <div class="grid">
                    <div class="col-12 md:col-6 lg:col-4"><strong>Status:</strong>
                        <div class="mt-1">{{ settlement.status?.statusName }}</div>
                    </div>
                    <div class="col-12 md:col-6 lg:col-4"><strong>Text Reference:</strong>
                        <div class="mt-1">{{ settlement.proposedTextReference || 'N/A' }}</div>
                    </div>
                    <div class="col-12 md:col-6 lg:col-4"><strong>Proposed AR GL Code:</strong>
                        <div class="mt-1">{{ settlement.proposedArGlCodeCombination || 'N/A' }}</div>
                    </div>
                    <div class="col-12 md:col-6 lg:col-4"><strong>Proposed AP GL Code:</strong>
                        <div class="mt-1">{{ settlement.proposedApGlCodeCombination || 'N/A' }}</div>
                    </div>
                </div>
            </p-fieldset>
        </div>

        <div class="mt-4">
            <p-fieldset legend="Attachments" [toggleable]="true" class="mb-4">
                <div class="mb-4">
                    <p-fileUpload name="attachments[]" (onSelect)="onFileSelect($event)" [multiple]="true"
                        [accept]="attachmentAcceptTypes" [maxFileSize]="maxFileSize"
                        [showUploadButton]="false" [showCancelButton]="false" chooseLabel="Add Attachment"
                        chooseIcon="pi pi-plus" styleClass="p-button-outlined"
                        [disabled]="isUploadingAttachments || isSavingAttachments">
                    </p-fileUpload>
                </div>

                <div class="mb-3" *ngIf="isUploadingAttachments">
                    <div class="mb-2 text-600 text-sm">Uploading attachments {{ attachmentUploadProgress }}%</div>
                    <p-progressBar [value]="attachmentUploadProgress"></p-progressBar>
                </div>

                <div class="flex justify-content-end mb-3">
                    <p-button label="Save Attachment Changes" icon="pi pi-save" (click)="saveAttachments()"
                        [loading]="isUploadingAttachments || isSavingAttachments"
                        [disabled]="!attachmentsChanged || isUploadingAttachments || isSavingAttachments"></p-button>
                </div>

                <p-table [value]="settlement.attachments" styleClass="p-datatable-sm" responsiveLayout="scroll"
                    *ngIf="settlement.attachments && settlement.attachments.length > 0">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>File Name</th>
                            <th>Size</th>
                            <th>Uploaded By</th>
                            <th>Uploaded Date</th>
                            <th style="width: 10rem">Actions</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-attachment>
                        <tr>
                            <td>
                                <i class="pi pi-file mr-2"></i>
                                {{ attachment.fileName }}
                            </td>
                            <td>{{ formatFileSize(attachment.fileSize) }}</td>
                            <td>{{ attachment.uploadedBy || 'N/A' }}</td>
                            <td>{{ attachment.uploadedDate ? (attachment.uploadedDate | appDate:'medium') : 'N/A' }}</td>
                            <td>
                                <div class="flex gap-2">
                                    <button pButton pRipple icon="pi pi-eye" class="p-button-rounded p-button-info"
                                        (click)="viewAttachment(attachment)" pTooltip="View"
                                        [disabled]="!attachment.attachmentId && !attachment.fileUrl"></button>
                                    <button pButton pRipple icon="pi pi-download"
                                        class="p-button-rounded p-button-success"
                                        (click)="downloadAttachment(attachment)" pTooltip="Download in new tab"
                                        [disabled]="!attachment.attachmentId && !attachment.fileUrl"></button>
                                    <button pButton pRipple icon="pi pi-envelope" class="p-button-rounded p-button-help"
                                        (click)="emailAttachment(attachment)" pTooltip="Email"
                                        [disabled]="!attachment.attachmentId && !attachment.fileUrl"></button>
                                </div>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>

                <div *ngIf="!settlement.attachments || settlement.attachments.length === 0"
                    class="text-center text-600 p-3">
                    No attachments found.
                </div>

            </p-fieldset>

        </div>
    </div>
</div>

<div *ngIf="!isLoading && !settlement" class="p-4 text-center">
    <p>Could not load settlement data. Please check the ID and try again.</p>
</div>

<!-- A&P Details Dialog -->
<p-dialog header="Edit A&P Details" [(visible)]="displayApDialog" [modal]="true" [style]="{width: '70vw'}">
    <form [formGroup]="apDetailsForm" (ngSubmit)="saveApDetails()">
        <div class="grid formgrid p-fluid">
            <div class="field col-12 md:col-6">
                <p-inputgroup>
                    <p-inputgroup-addon><i class="pi pi-ticket"></i></p-inputgroup-addon>
                    <p-iftalabel>
                        <input type="text" pInputText formControlName="apVoucher" id="apVoucher" class="w-full">
                        <label for="apVoucher">AP Voucher</label>
                    </p-iftalabel>
                </p-inputgroup>
            </div>
            <div class="field col-12 md:col-6">
                <p-inputgroup>
                    <p-inputgroup-addon><i class="pi pi-money-bill"></i></p-inputgroup-addon>
                    <p-iftalabel>
                        <p-inputNumber formControlName="apValue" mode="currency" currency="SAR" inputId="apValue" inputStyleClass="w-full" [min]="-999999999999"></p-inputNumber>
                        <label for="apValue">A&P Value</label>
                    </p-iftalabel>
                </p-inputgroup>
            </div>
            <div class="field col-12 md:col-6">
                <p-inputgroup>
                    <p-inputgroup-addon><i class="pi pi-percentage"></i></p-inputgroup-addon>
                    <p-iftalabel>
                        <p-inputNumber formControlName="apVat" mode="currency" currency="SAR" inputId="apVat" inputStyleClass="w-full" [min]="-999999999999"></p-inputNumber>
                        <label for="apVat">A&P VAT</label>
                    </p-iftalabel>
                </p-inputgroup>
            </div>
            <div class="field col-12 md:col-6">
                <p-inputgroup>
                    <p-inputgroup-addon><i class="pi pi-calculator"></i></p-inputgroup-addon>
                    <p-iftalabel>
                        <p-inputNumber formControlName="apTotalAmount" mode="currency" currency="SAR" [disabled]="true" inputId="apTotalAmount" inputStyleClass="w-full" [min]="-999999999999"></p-inputNumber>
                        <label for="apTotalAmount">A&P Total</label>
                    </p-iftalabel>
                </p-inputgroup>
            </div>
            <div class="field col-12 md:col-6">
                <p-inputgroup>
                    <p-inputgroup-addon><i class="pi pi-code"></i></p-inputgroup-addon>
                    <p-iftalabel>
                        <input type="text" pInputText formControlName="apArGlCodeCombination" id="apArGlCode" class="w-full">
                        <label for="apArGlCode">A&P AR GL Code</label>
                    </p-iftalabel>
                </p-inputgroup>
            </div>
            <div class="field col-12 md:col-6">
                <p-inputgroup>
                    <p-inputgroup-addon><i class="pi pi-code"></i></p-inputgroup-addon>
                    <p-iftalabel>
                        <input type="text" pInputText formControlName="apApGlCodeCombination" id="apApGlCode" class="w-full">
                        <label for="apApGlCode">A&P AP GL Code</label>
                    </p-iftalabel>
                </p-inputgroup>
            </div>
            <div class="field col-12 md:col-6">
                <p-inputgroup>
                    <p-inputgroup-addon><i class="pi pi-info-circle"></i></p-inputgroup-addon>
                    <p-iftalabel>
                        <input type="text" pInputText formControlName="apTextReference" id="apTextReference" class="w-full">
                        <label for="apTextReference">A&P Text Reference</label>
                    </p-iftalabel>
                </p-inputgroup>
            </div>
            <div class="field col-12 md:col-6">
                <p-inputgroup>
                    <p-inputgroup-addon><i class="pi pi-info-circle"></i></p-inputgroup-addon>
                    <p-iftalabel>
                        <input type="text" pInputText formControlName="supplier" id="supplier" class="w-full">
                        <label for="supplier">Supplier</label>
                    </p-iftalabel>
                </p-inputgroup>
            </div>
            <!-- <div class="field col-12 md:col-6">
                <p-inputgroup>
                    <p-inputgroup-addon><i class="pi pi-truck"></i></p-inputgroup-addon>
                    <p-iftalabel>
                        <p-dropdown [options]="filteredSuppliers" formControlName="supplier" placeholder="Select a Supplier" [appendTo]="'body'"
                                    inputId="supplier" styleClass="w-full" [filter]="true">
                                    <ng-template let-supplier pTemplate="selectedItem">
                                        <div *ngIf="supplier">{{supplier.supplierNumber}} - {{supplier.supplierName}}</div>
                                    </ng-template>
                                    <ng-template let-supplier pTemplate="item">
                                        <div>{{supplier.supplierNumber}} - {{supplier.supplierName}}</div>
                                    </ng-template>
                                    <ng-template pTemplate="filter" let-supplier>
                                        <p-inputgroup>
                                            <p-inputgroup-addon>
                                                <i class="pi pi-search"></i>
                                            </p-inputgroup-addon>
                                            <input #customerInput type="text" pInputText placeholder="Filter" (keyup)="filterSuppliers($event)">
                                            <p-button type="button" icon="pi pi-times" (click)="supplier.reset(); customerInput.value = ''" 
                                                styleClass="p-button-secondary"></p-button>
                                        </p-inputgroup>
                                    </ng-template>
                                </p-dropdown>
                        <label for="supplier">Supplier</label>
                    </p-iftalabel>
                </p-inputgroup>
            </div> -->
            
            <div class="field col-12 md:col-6">
                <p-inputgroup>
                    <p-inputgroup-addon><i class="pi pi-receipt"></i></p-inputgroup-addon>
                    <p-iftalabel>
                        <p-dropdown [options]="['Yes','No']" formControlName="serviceInvoice" placeholder="Select Yes/No" inputId="serviceInvoice" styleClass="w-full"></p-dropdown>
                        <label for="serviceInvoice">Service Invoice</label>
                    </p-iftalabel>
                </p-inputgroup>
            </div>
            <div class="field col-12 md:col-6">
               <p-inputgroup>
                    <p-inputgroup-addon><i class="pi pi-hashtag"></i></p-inputgroup-addon>
                    <p-iftalabel>
                        <input type="number" pInputText formControlName="arTrxNo" id="arTrxNo" class="w-full">
                        <label for="arTrxNo">AR TRX No</label>
                    </p-iftalabel>
                </p-inputgroup>
            </div>
        </div>
        <div class="p-dialog-footer mt-4 flex justify-content-end gap-2">
            <p-button label="Cancel" icon="pi pi-times" styleClass="p-button-text" (click)="displayApDialog=false"></p-button>
            <p-button label="Save" icon="pi pi-check" type="submit" [loading]="isSaving"></p-button>
        </div>
    </form>
</p-dialog>

<!-- AR Finance Details Dialog -->
<p-dialog header="Edit AR Finance Details" [(visible)]="displayArDialog" [modal]="true" [style]="{width: '30vw'}">
    
    <form [formGroup]="arFinanceForm" (ngSubmit)="saveArFinanceDetails()">
        <div class="grid formgrid p-fluid">
            <div class="field col-12">

                <p-inputgroup>
                    <p-inputgroup-addon><i class="pi pi-hashtag"></i></p-inputgroup-addon>

                    <p-iftalabel>
                        <input type="text" pInputText formControlName="arCmHash" id="arCmNumber" class="w-full">
                        <label for="arCmNumber">AR CM#</label>
                    </p-iftalabel>
                </p-inputgroup>
                
                <!-- <p-inputgroup>
                    <p-inputgroup-addon><i class="pi pi-hashtag"></i></p-inputgroup-addon>
                    <p-iftalabel>
                        <input type="text" pInputText formControlName="arTrxNo" id="arTrxNo" class="w-full">
                        <label for="arTrxNo">AR TRX No</label>
                    </p-iftalabel>
                </p-inputgroup> -->
            </div>
        </div>
        <div class="p-dialog-footer mt-4 flex justify-content-end gap-2">
            <p-button label="Cancel" icon="pi pi-times" styleClass="p-button-text" (click)="displayArDialog=false"></p-button>
            <p-button label="Save" icon="pi pi-check" type="submit" [loading]="isSaving"></p-button>
        </div>
    </form>
</p-dialog>

<!-- PDF Viewer Dialog -->
<p-dialog header="View Attachment" [(visible)]="pdfViewerVisible" [modal]="true" [style]="{width: '80vw', height: '90vh'}" [maximizable]="true">
    <ng-template pTemplate="content">
        <ngx-extended-pdf-viewer [src]="pdfSrc!" height="85vh"></ngx-extended-pdf-viewer>
    </ng-template>
</p-dialog>

<!-- Image Viewer Dialog -->
<p-dialog header="View Image" [(visible)]="imageViewerVisible" [modal]="true" [style]="{width: '80vw', height: '90vh'}" [maximizable]="true">
    <ng-template pTemplate="content">
        <div class="flex justify-content-center align-items-center h-full">
            <img [src]="imageSrc!" alt="Image Attachment" style="max-width: 100%; max-height: 85vh; object-fit: contain;">
        </div>
    </ng-template>
</p-dialog>

<!-- Office Document Viewer Dialog (Word, Excel, PowerPoint) -->
<p-dialog header="View Document" [(visible)]="officeViewerVisible" [modal]="true" [style]="{width: '80vw', height: '90vh'}" [maximizable]="true">
    <ng-template pTemplate="content">
        <iframe [src]="officeSrc" width="100%" height="100%" frameborder="0"></iframe>
    </ng-template>
</p-dialog>

<!-- EML Viewer Dialog -->
<p-dialog header="View Email" [(visible)]="emlViewerVisible" [modal]="true" [style]="{width: '80vw', height: '90vh'}" [maximizable]="true">
    <ng-template pTemplate="content">
        <iframe [src]="emlSrc" width="100%" height="100%" frameborder="0"></iframe>
    </ng-template>
</p-dialog>
